export default __webpack_public_path__ + "static/media/avatar-s-6.974f64da.jpg";